import { render, staticRenderFns } from "./PartnerTag.vue?vue&type=template&id=5ac948bf&scoped=true&"
import script from "./PartnerTag.vue?vue&type=script&lang=js&"
export * from "./PartnerTag.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTag.vue?vue&type=style&index=0&id=5ac948bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac948bf",
  null
  
)

component.options.__file = "PartnerTag.vue"
export default component.exports